import * as Yup from "yup";

const Validation = Yup.object({
  name: Yup.string().required("Please enter name!"),
  energy: Yup.number().required("Please enter energy!"),
  price: Yup.number().required("Please enter price!"),
  logo: Yup.string().required("Please upload logo icon!"),
  // currency: Yup.string().required("Please select currency!"),
  // isHotOffer: Yup.boolean().optional().default(false)
});

export default Validation;
